import React, {ReactElement, useCallback, useMemo} from 'react'
import {ThemeColor} from 'themes'
import {useWindowMode} from 'windows'
import {
  TemplateDropboxContentPreview,
  DropboxContentPreviewData,
} from 'pages/templates'

export default function DropboxUploadPreview({
  data: base,
  color,
  renderNewUpload,
  renderHeader,
}: {
  data: File[]
  color?: ThemeColor
  renderNewUpload(): ReactElement
  renderHeader?(): ReactElement
}) {
  const mode = useWindowMode()

  const data = useMemo(
    () =>
      base.map<DropboxContentPreviewData>((item) => ({
        name: item.name,
        src: item,
      })),
    [base],
  )

  const keyExtractor = useCallback(
    (item: DropboxContentPreviewData) => item.name,
    [],
  )

  const handleRenderFooter = useMemo(
    () => (mode !== 'website' ? renderNewUpload : undefined),
    [mode, renderNewUpload],
  )

  return (
    <TemplateDropboxContentPreview
      color={color}
      data={data}
      keyExtractor={keyExtractor}
      renderFooter={handleRenderFooter}
      renderHeader={renderHeader}
    />
  )
}
